import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import VisitorEnquiryLayer from "../components/VisitorEnquiryLayer";

const VisitorEnquiryPage = () => {
    return (
        <MasterLayout>
            <VisitorEnquiryLayer />
        </MasterLayout>
    );
};

export default VisitorEnquiryPage;
